export const STATUS_ORDER = ["healthy", "warning", "critical", "unknown"];
export const STATUS_ICONS = {
  healthy: "check_circle",
  warning: "warning",
  critical: "error",
  unknown: "help"
};
export const STATUS_BADGE_COLORS = {
  healthy: "success",
  warning: "warning",
  critical: "danger",
  unknown: "gray"
};
export const STATUS_LABELS = {
  healthy: "Healthy",
  warning: "Warning",
  critical: "Critical",
  unknown: "Unknown"
};
export const STATUS_DESCRIPTION = {
  healthy: "Functioning properly.",
  warning: "Experiencing a problem that needs attention.",
  critical: "Severe issues that are negatively impacting functionality.",
  unknown: "The state could not be evaluated."
};
export const getStatusMeta = (status) => ({
  label: STATUS_LABELS[status],
  description: STATUS_DESCRIPTION[status]
});
